import * as RasaInput from '../../../components/rasa-input'
import * as Types from './types'

export const modalStateValid = (state: Types.ModalData): boolean =>
  !RasaInput.validateEmail(state.email).invalid



// WEBPACK FOOTER //
// ./src/pages/members/add-modal/utils.ts